import { useLots, useProperties } from '@/api/hooks';
import {
  LotFormModal,
  LotsTableWithActions,
} from '@/components/features/lots/PropertyLotsPanel';
import { Button } from '@/components/ui/Button';
import { Card, CardBody } from '@/components/ui/Card';
import { EmptyState } from '@/components/ui/EmptyState';
import { PageHeader } from '@/components/ui/PageHeader';
import { usePropertyScope } from '@/contexts/PropertyContext';
import { Layers, Plus } from 'lucide-react';
import { useState } from 'react';

export function LotsPage() {
  const { propertyId } = usePropertyScope();
  const { data: propertiesData } = useProperties();
  const activeProperty = propertiesData?.properties.find((p) => p.id === propertyId);
  const { data, isLoading } = useLots(propertyId);
  const [open, setOpen] = useState(false);

  return (
    <div>
      <PageHeader
        title="Lotes"
        subtitle="Locais físicos ou virtuais dentro da fazenda — pastos, currais, enfermaria…"
        actions={
          propertyId ? (
            <Button onClick={() => setOpen(true)}>
              <Plus className="h-4 w-4" />
              Novo lote
            </Button>
          ) : undefined
        }
      />

      {!propertyId ? (
        <Card>
          <CardBody className="py-10 text-center text-manejai-bark/60">
            Selecione uma <strong>fazenda ativa</strong> no topo para ver e cadastrar lotes.
          </CardBody>
        </Card>
      ) : isLoading ? (
        <div className="space-y-2">
          {[1, 2, 3].map((i) => (
            <div key={i} className="h-14 rounded-xl bg-manejai-sand/40 animate-pulse" />
          ))}
        </div>
      ) : (data?.lots.length ?? 0) === 0 ? (
        <Card>
          <EmptyState
            icon={Layers}
            title="Nenhum lote nesta fazenda"
            description="Cadastre pastos, currais ou enfermarias para organizar o rebanho e registrar transferências entre locais."
            action={
              <Button onClick={() => setOpen(true)}>
                <Plus className="h-4 w-4" />
                Cadastrar lote
              </Button>
            }
          />
        </Card>
      ) : (
        <Card>
          <LotsTableWithActions
            lots={data!.lots}
            propertyName={activeProperty?.name ?? 'Fazenda'}
            propertyId={propertyId}
            footer={
              <div className="px-5 py-3 border-t border-manejai-sand/60 text-xs text-manejai-bark/50">
                {data?.meta.total} lote(s) · clique na linha para ver os animais do lote
              </div>
            }
          />
        </Card>
      )}

      {propertyId && activeProperty && (
        <LotFormModal
          open={open}
          onClose={() => setOpen(false)}
          propertyId={propertyId}
          propertyName={activeProperty.name}
        />
      )}
    </div>
  );
}
